import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest } from "redux-saga/effects";
import { searchApi } from "../../services/search.api";
import { Patient, PublicPatient } from "../../types/patient.definition";
import { PaginationSettingsResponse } from "../../types/search.definition";
import { SearchRequest } from "../../types/search.definition";
import {
  fetchPatientsFailure,
  fetchPatientsRequest,
  fetchPatientsSuccess,
} from "../reducers/patientSlice";

type PatientSearchResponse = {
  data: PublicPatient[];
  paginationSettings: PaginationSettingsResponse;
};

function* fetchPatientsSaga({
  payload,
}: PayloadAction<{ facilityId: number; searchRequest: SearchRequest }>): Generator<
  unknown,
  void,
  PatientSearchResponse
> {
  try {
    const response = yield call(
      searchApi.searchPatientsInFacility,
      payload.searchRequest,
      payload.facilityId
    );

    yield put(
      fetchPatientsSuccess({
        // The facility search returns PublicPatient-shaped data (id, firstName, lastName,
        // email, phoneNumber, civility, age, photoUrl). Cast to Patient[] since the slice
        // stores Patient[] and all displayed list fields are present.
        patients: (response.data || []) as unknown as Patient[],
        totalItems: response.paginationSettings?.totalCount || 0,
        paginationSettings: {
          limit: payload.searchRequest.paginationSettings.limit,
          offset: payload.searchRequest.paginationSettings.offset || 0,
        },
      })
    );
  } catch (error) {
    yield put(
      fetchPatientsFailure(
        error instanceof Error ? error.message : "Failed to fetch patients"
      )
    );
  }
}

export function* watchPatients() {
  yield takeLatest(fetchPatientsRequest.type, fetchPatientsSaga);
}

